<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { applyPwaUpdate } from '@/plugins/pwa'

const offline = ref(typeof navigator !== 'undefined' ? !navigator.onLine : false)
const updateAvailable = ref(false)

const syncOnline = () => {
  offline.value = !navigator.onLine
}

const onUpdateAvailable = () => {
  updateAvailable.value = true
}

onMounted(() => {
  window.addEventListener('online', syncOnline)
  window.addEventListener('offline', syncOnline)
  window.addEventListener('fitx:pwa-update-available', onUpdateAvailable)
})

onUnmounted(() => {
  window.removeEventListener('online', syncOnline)
  window.removeEventListener('offline', syncOnline)
  window.removeEventListener('fitx:pwa-update-available', onUpdateAvailable)
})

const refreshUpdate = () => {
  applyPwaUpdate()
}
</script>

<template>
  <div
    v-if="offline || updateAvailable"
    class="fitx-pwa-banners"
  >
    <VAlert
      v-if="offline"
      type="warning"
      variant="tonal"
      density="compact"
      class="ma-0 rounded-0"
      role="status"
      data-testid="pwa-offline-banner"
    >
      {{ $t('pwa.offlineBanner') }}
    </VAlert>
    <VAlert
      v-if="updateAvailable"
      type="info"
      variant="tonal"
      density="compact"
      class="ma-0 rounded-0"
      role="status"
      data-testid="pwa-update-banner"
    >
      <div class="d-flex align-center justify-space-between flex-wrap gap-2">
        <span>{{ $t('pwa.updateAvailable') }}</span>
        <VBtn
          size="small"
          color="primary"
          variant="text"
          @click="refreshUpdate"
        >
          {{ $t('pwa.refreshToUpdate') }}
        </VBtn>
      </div>
    </VAlert>
  </div>
</template>
